package com.yogaaicoach.common.core.extensions

import kotlin.time.Duration

fun Duration.format(): String {
    val hours = this.toHoursPart()
    val minutes = this.toMinutesPart()
    val seconds = this.toSecondsPart()
    return if (hours > 0) {
        "${formatTwoDigits(hours)}:${formatTwoDigits(minutes)}:${formatTwoDigits(seconds)}"
    } else {
        "${formatTwoDigits(minutes)}:${formatTwoDigits(seconds)}"
    }
}

private fun formatTwoDigits(value: Long): String {
    return if (value < 10) "0$value" else value.toString()
}

private fun Duration.toMinutesPart(): Long = this.inWholeMinutes % 60
private fun Duration.toSecondsPart(): Long = this.inWholeSeconds % 60
fun Duration.toHoursPart(): Long = this.inWholeHours

